import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll imediato para o topo ao mudar de rota (sem animação para ser instantâneo)
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;